import { ProductsCategory } from '../../../config';
import { productsKeyConstants } from '../../../config/products';
import { UnOrderedList, OrderedNumberList } from './helpers';
import Link from 'next/link';
import Styles from './faq.module.scss';
import { getProducts } from '../../../commons/utils/productsHelper';
const products = getProducts();
const rfPrice = products[productsKeyConstants.RF_RELIEF_FACTOR_QS];
const reliefFactor = [
  {
    title: 'What is Relief Factor?',
    content:
      'Relief Factor is a health supplement for pain relief. It is a non-addictive, drug-free product that provides relief from everyday aches and pains.',
  },
  {
    title: 'What kind of pain does Relief Factor help?',
    content: UnOrderedList(
      'Relief Factor supports your body’s natural healing abilities in response to:',
      [
        'Back pain',
        'Neck pain',
        'Shoulder pain',
        'Elbow pain',
        'Wrist pain',
        'Hand pain',
        'Hip pain',
        'Knee pain',
        'Ankle pain',
        'Foot pain',
      ]
    ),
  },
  {
    title: 'How does Relief Factor work?',
    content:
      "Relief Factor supports the body’s natural response to inflammation, providing relief from aches and pains commonly caused by aging, exercise, and everyday living. It's 100%-drug-free and easy to use, without unpleasant side effects.",
  },
  {
    title: 'What is Relief Factor made of?',
    content: OrderedNumberList(
      'Relief Factor has four essential ingredients:',
      [
        `<b>Omega-3s (fish oil)</b> support healthy tissues and promote the body’s natural healing abilities.`,
        '<b>Curcumin</b> helps the body decrease swelling, relieve stiff joints, and reduce pain during movement.',
        '<b>Resveratrol</b> is a free-radical neutralizer that supports blood vessel health.',
        '<b>Icariin</b> helps blood flow and promotes tissue health.',
      ]
    ),
  },
  {
    title: 'Does Relief Factor reduce inflammation?',
    content:
      'Relief Factor supports your body’s healthy response to inflammation through four metabolic pathways. They help reduce muscle pain, swelling, stiffness, and other symptoms that cause pain.',
  },
  {
    title: 'How long does it take to feel the difference?',
    content:
      'With severe or long-term aches and pains, 3 doses per day after the first week may be required. It may actually take several weeks at a higher dosage to see improvement as every body is different. ',
  },
  {
    title: 'Is Relief Factor safe?',
    content:
      'Yes. Many of the ingredients in Relief Factor are found in the foods we consume. Yet, Relief Factor is clinically designed to provide those ingredients in a specific combination and potency to help the body reduce or eliminate aches and pains.',
  },
  {
    title: 'Does Relief Factor’s Omega-3s contain heavy metals?',
    content:
      'No. We use wild-caught mackerel, anchovy, and sardine oil, distilled to remove impurities, including heavy metals. Distillation is the process of separating, purifying, and concentrating natural products, which minimizes losses due to thermal decomposition, thereby keeping the oil pure.',
  },
  {
    title: 'Does Relief Factor have a fishy taste?',
    content:
      'Our capsules are not flavored. The gel caps are designed to delay breakdown until they are further along the digestive tract. Therefore, you shouldn’t notice any taste at all.',
  },
  {
    title: 'Where are Relief Factor’s ingredients sourced from?',
    content: 'Each ingredient is sourced from the United States and globally.',
  },
  {
    title: 'Is Relief Factor a pill or drink?',
    content:
      'Each dose of Relief Factor consists of two gel caps and two capsules packaged in a convenient easy-to-open cellophane packet. The capsules are average-sized (less than an inch long and only a quarter inch wide). Most people find them easy to swallow, and you can always open the capsules and sprinkle the contents into a drink or food, like applesauce.',
  },
  {
    title: "What's the monthly cost of Relief Factor?",
    content: `Relief Factor is a reasonably priced supplement at $${rfPrice.recurringPrice} with a subscription, plus shipping and handling and any applicable sales tax.`,
  },
];
const zenFactor = [
  {
    title: 'Is Zen Factor addictive?',
    content:
      'No. The ingredients in our formula are 100% drug-free, all-natural, non-habit forming.',
  },
  {
    title: 'Will Zen Factor make me drowsy?',
    content:
      'No. Zen Factor can support a nice, restful night of sleep, but is not a “sleeping pill” and should not cause any drowsiness.',
  },
  {
    title: 'When should I take Zen Factor?',
    content: 'We suggest taking one capsule in the morning and one at night. ',
  },
  {
    title:
      'Will Zen Factor negatively interact with other medications I’m taking?',
    content:
      'With any medication, we advise that you consult with your physician before taking our product.',
  },
  {
    title: 'Can Zen Factor be used as a sleep aid?',
    content: (function outer() {
      return (
        <div className={Styles.linkClass}>
          Zen Factor can support a nice, restful night of sleep but is not a
          “sleeping pill” and should not cause any drowsiness. If you are
          struggling with sleep, we recommend trying out our product{' '}
          <Link href="/products/z-factor">Z Factor</Link>.
        </div>
      );
    })(),
  },
];
const goFactor = [
  {
    title: 'What time of day should I take Go Factor? ',
    content: UnOrderedList('Anytime you need an extra boost! That could be: ', [
      'Mid-morning or during mid-afternoon slumps',
      'When your schedule gets busy',
      'During long work or school days',
      'On long drives or commutes',
      'After working out',
      '(Avoid taking within 4 hours of bedtime)',
    ]),
  },
  {
    title: 'Should I take Go Factor with food?',
    content:
      'Yes, take it with food or as recommended by your physician. Go Factor gives your body a healthy dose of a complete B-complex—nutrients your body needs to process food into energy—and taurine—an amino acid that helps your body process fat and recover from exertion.',
  },
  {
    title: 'Are there any possible side effects? ',
    content: UnOrderedList('', [
      `Taurine has no known side effects when taken in reasonable doses. The most common dosages of taurine are 500 mg to 2,000 mg per day. Go Factor only contains 750 mg per dose.`,
      `Caffeine in high doses can cause side effects, such as anxiety, insomnia, or loose stool. However, Go Factor has a low dose of caffeine—50 mg, or about half a cup of coffee.`,
      `B-complex supplements can turn urine bright yellow. Discolored urine can be surprising, but it’s not dangerous. It’s simply your body eliminating excess nutrients.`,
    ]),
  },
  {
    title:
      'Can I take Go Factor if I’m pregnant or nursing? Can I take Go Factor if I have a health condition or injury? Can I take it with other medications? ',
    content:
      'These are great questions for your doctor or pharmacist. Go Factor contains a complete B vitamin complex, taurine, and caffeine.',
  },
];
const zFactor = [
  {
    title: 'Will Z Factor cause drowsiness in the morning?',
    content:
      'Z Factor does not leave you drowsy the next day. The ingredient GABA helps you wake up feeling rested and refreshed after a great night’s sleep.',
  },
  {
    title: 'Is Z Factor addictive?',
    content: 'It is a 100% drug-free, non-addictive sleep supplement.',
  },
  {
    title: 'Should I take Z Factor with or without food?',
    content:
      "Without food, you experience faster absorption, and Z Factor won't upset your empty stomach. It’s recommended to eat a lighter dinner.",
  },
  {
    title:
      'Does Z Factor contain a typical dose of melatonin or is it a reduced dose?',
    content:
      'A typical melatonin product contains 3-5 mg. Z Factor contains only 1 mg per capsule. We used this lower dosage because some smaller individuals need less, and some people are more sensitive to melatonin. It’s okay to take additional melatonin with Z Factor if you’d like, or as suggested by your doctor.',
  },
  {
    title: 'Are there any interactions?',
    content:
      'Do not take Z Factor with other sedative medications. If pain is interrupting your sleep, consider taking Relief Factor.',
  },
  {
    title: 'Does melatonin cause vivid dreams or nightmares? ',
    content:
      'It is uncommon to experience vivid dreams or nightmares with the dose of melatonin in Z Factor. We recommend lowering your dosage if you experience uncomfortably vivid dreams.',
  },
  {
    title:
      'Do I have to take Z Factor continuously to experience benefits? Or will taking one capsule have a noticeable effect? ',
    content:
      'You should feel a noticeable effect the first night you take Z Factor. Take nightly as needed for best results.',
  },
  {
    title: 'Is Z Factor safe for children?',
    content: 'Z Factor is not designed for use with children.',
  },
  {
    title: 'How safe is Z Factor for people with sleep apnea? ',
    content:
      'As is the case with any medical condition we advise that you consult with your physician before taking our product.',
  },
];
export const faqContents = {
  [ProductsCategory.RELIEF_FACTOR]: reliefFactor,
  [ProductsCategory.ZEN_FACTOR]: zenFactor,
  [ProductsCategory.GO_FACTOR]: goFactor,
  [ProductsCategory.Z_FACTOR]: zFactor,
  // [ProductsCategory.THINK_FACTOR]: thinkFactor,
};
